import { render, staticRenderFns } from "./MenuAttachments.vue?vue&type=template&id=3ffc3b40"
import script from "./MenuAttachments.vue?vue&type=script&lang=js"
export * from "./MenuAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports